export default function setGlobalTimezone(timezone = null) {
  if (timezone) {
    window.timezone = timezone
  }
}
